import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureUsageHeatmap = ({ data }) => {
  const getAdoptionColor = (rate) => {
    const numRate = parseFloat(rate);
    if (numRate >= 80) return 'bg-success/20 text-success border-success/30';
    if (numRate >= 60) return 'bg-accent/20 text-accent border-accent/30';
    if (numRate >= 40) return 'bg-warning/20 text-warning border-warning/30';
    return 'bg-error/20 text-error border-error/30';
  };

  const getCategoryIcon = (category) => {
    const icons = {
      compliance: 'Shield',
      payroll: 'DollarSign',
      leave: 'Calendar',
      workforce: 'Users',
      employee: 'UserCheck',
      contract: 'FileText',
      approval: 'CheckCircle',
      audit: 'Eye',
      calendar: 'CalendarDays',
      policy: 'Book'
    };
    return icons?.[category] || 'Activity';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="mb-6">
        <h3 className="font-heading font-semibold text-base md:text-lg text-foreground mb-1">
          Feature Usage Matrix
        </h3>
        <p className="caption text-xs md:text-sm text-muted-foreground">
          Adoption rates across all HR modules with usage frequency
        </p>
      </div>

      <div className="space-y-3">
        {data?.slice(0, 8)?.map((feature, index) => (
          <div 
            key={index}
            className="flex items-center gap-3 p-3 bg-muted/30 rounded-md hover:bg-muted/50 transition-smooth"
          >
            <div className="flex-shrink-0">
              <div className="bg-primary/10 text-primary p-2 rounded-md">
                <Icon name={getCategoryIcon(feature?.featureCategory)} size={18} color="currentColor" />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-heading text-sm font-medium text-foreground truncate">
                {feature?.featureName}
              </p>
              <p className="caption text-xs text-muted-foreground capitalize">
                {feature?.featureCategory} • {feature?.totalUsage} uses
              </p>
            </div>
            <div className="flex-shrink-0">
              <div className={`px-3 py-1 rounded-full border ${getAdoptionColor(feature?.adoptionRate)}`}>
                <span className="data-text text-xs font-bold">
                  {feature?.adoptionRate}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-xs">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-success"></div>
            <span className="caption text-muted-foreground">High (≥80%)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-accent"></div>
            <span className="caption text-muted-foreground">Good (60-79%)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-warning"></div>
            <span className="caption text-muted-foreground">Fair (40-59%)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-error"></div>
            <span className="caption text-muted-foreground">Low (&lt;40%)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureUsageHeatmap;
